import styled from 'styled-components'

export const FormContainerStyles = styled.div`
  margin: -2rem;
  padding: 2rem;
  border-top: 0.1rem solid ${({ theme }) => theme.palette.grey.A700};
`
